import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { DateToStringDate } from '../../../../../services/date';
import { BondInsuranceHiredDataForGetCompleteBondInsurancePolicyByIdResponseDTO } from '../../../../../dtos/bond-insurance-policy-list/get-complete-bond-insurance-policy-by-id-response.dto';
import { getBondInsurancePolicyStatusLabel } from '../../../../../services/bond-insurance-policy';
import { maskMoney } from '../../../../../services/masks';
import { PreviousHiredButton } from '../../../styles';
import { BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO } from '../../../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';

export type Props = {
  bondInsuranceHiredData: BondInsuranceHiredDataForGetCompleteBondInsurancePolicyByIdResponseDTO;
  bondInsuranceAnalysis: BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO;
  getPreviousHired: Function;
};

const FieldDisplay = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div style={{ paddingBottom: '16px' }}>
    <div
      style={{
        fontWeight: 'bold',
        marginBottom: '0.35em',
        color: '#555',
        fontSize: '0.85em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: '0.95em', wordBreak: 'break-word' }}>
      {value || 'Indisponível'}
    </div>
  </div>
);

export const BondInsurancePolicyMainInfoDetails = (props: Props) => {
  const { bondInsuranceHiredData, bondInsuranceAnalysis, getPreviousHired } = props;
  return (
    <div style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      {bondInsuranceHiredData.previousHiredDataId !== null && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '10px'
          }}
        >
          <PreviousHiredButton
            onClick={() => {
              getPreviousHired(bondInsuranceHiredData.previousHiredDataId);
            }}
          >
            <Icon name="reply" color="blue" />
            Ver apólice original
          </PreviousHiredButton>
        </div>
      )}

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="ID" value={bondInsuranceHiredData.id} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="STATUS"
            value={getBondInsurancePolicyStatusLabel(bondInsuranceHiredData.status)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="CÓD. DA APÓLICE"
            value={bondInsuranceHiredData.insurerPolicyId}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="DATA DE EMISSÃO DA APÓLICE"
            value={
              bondInsuranceHiredData.insurerPolicyCreatedAt
                ? DateToStringDate(bondInsuranceHiredData.insurerPolicyCreatedAt)
                : 'Indisponível'
            }
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="Nº DE PARCELAS CONTRATADAS"
            value={
              bondInsuranceHiredData.hiredInstallments
                ? Number(bondInsuranceHiredData.hiredInstallments)
                : 'Indisponível'
            }
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="VALOR DA PARCELA (R$)"
            value={
              bondInsuranceHiredData.hiredInstallmentsValue
                ? maskMoney(
                    String(bondInsuranceHiredData.hiredInstallmentsValue),
                    true,
                    2
                  )
                : 'Indisponível'
            }
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="FORMA DE PAGAMENTO"
            value={bondInsuranceHiredData.paymentWay}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="PRÊMIO TOTAL"
            value={
              bondInsuranceHiredData.totalPremiumAmount &&
              bondInsuranceHiredData.totalPremiumAmount > 0
                ? maskMoney(String(bondInsuranceHiredData.totalPremiumAmount), true, 2)
                : bondInsuranceHiredData.hiredInstallmentsValue &&
                  bondInsuranceHiredData.hiredInstallments
                ? maskMoney(
                    String(
                      bondInsuranceHiredData.hiredInstallmentsValue *
                        bondInsuranceHiredData.hiredInstallments
                    ),
                    true,
                    2
                  )
                : 'Indisponível'
            }
          />
        </div>
      </div>

      {(bondInsuranceAnalysis?.observations || bondInsuranceHiredData?.observations) && (
        <div style={{ display: 'flex', width: '100%' }}>
          {bondInsuranceAnalysis?.observations && (
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay
                label="Observações análise"
                value={bondInsuranceAnalysis.observations}
              />
            </div>
          )}
          {bondInsuranceHiredData?.observations && (
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay
                label="Observações Contratação"
                value={bondInsuranceHiredData.observations}
              />
            </div>
          )}
          {!bondInsuranceAnalysis?.observations &&
            bondInsuranceHiredData?.observations && <div style={{ flex: 1 }}></div>}
          {bondInsuranceAnalysis?.observations &&
            !bondInsuranceHiredData?.observations && <div style={{ flex: 1 }}></div>}
        </div>
      )}

      {(bondInsuranceHiredData?.nonRenewalReason ||
        bondInsuranceHiredData?.responsible) && (
        <div style={{ display: 'flex', width: '100%' }}>
          {bondInsuranceHiredData?.nonRenewalReason && (
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay
                label="Motivo De Não Renovação"
                value={bondInsuranceHiredData.nonRenewalReason}
              />
            </div>
          )}
          {bondInsuranceHiredData?.responsible && (
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay
                label="Responsável pela Renovação"
                value={bondInsuranceHiredData.responsible}
              />
            </div>
          )}
          {!bondInsuranceHiredData?.nonRenewalReason &&
            bondInsuranceHiredData?.responsible && <div style={{ flex: 1 }}></div>}
          {bondInsuranceHiredData?.nonRenewalReason &&
            !bondInsuranceHiredData?.responsible && <div style={{ flex: 1 }}></div>}
        </div>
      )}

      {(bondInsuranceHiredData?.editor || bondInsuranceHiredData?.confirmer) && (
        <div style={{ display: 'flex', width: '100%' }}>
          {bondInsuranceHiredData?.editor && (
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay label="EDITADO POR" value={bondInsuranceHiredData.editor} />
            </div>
          )}
          {bondInsuranceHiredData?.confirmer && (
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay
                label="CONFIRMADO POR"
                value={bondInsuranceHiredData.confirmer}
              />
            </div>
          )}
          {!bondInsuranceHiredData?.editor && bondInsuranceHiredData?.confirmer && (
            <div style={{ flex: 1 }}></div>
          )}
          {bondInsuranceHiredData?.editor && !bondInsuranceHiredData?.confirmer && (
            <div style={{ flex: 1 }}></div>
          )}
        </div>
      )}
    </div>
  );
};
